"use strict";
import { isProdEnv } from "utilities/src/environment/env";
function isAppUniswapOrg({ hostname }) {
  return hostname === "ring.exchange";
}
function isAppUniswapStagingOrg({ hostname }) {
  return hostname === "app.corn-staging.com";
}
export function isBrowserRouterEnabled() {
  if (isProdEnv()) {
    if (isAppUniswapOrg(window.location) || isAppUniswapStagingOrg(window.location) || isLocalhost(window.location)) {
      return true;
    }
    return false;
  }
  return true;
}
function isLocalhost({ hostname }) {
  return hostname === "localhost";
}
export function isRemoteReportingEnabled() {
  return true;
}
